import React, { Component } from 'react';
import { withRouter } from 'utilities/with_router';

class ContactPage extends Component {
	render() {
		return (
			<div>
				<div className="about-textbox">
					<h1>Contact</h1>
					<p>
						If your organization or project would like to join the Constellation Network, please
						reach out to us: write@theconstellation.network
					</p>
					<br />
					<p>
						We also welcome general inquiries about LGBTQ+ prisoner support, though responses may
						be slow as our inbox is maintained by an all-volunteer group of core network
						organizers.
					</p>
				</div>
			</div>
		);
	}
}

export default withRouter(ContactPage);
